import { apiInstance } from '../api';
import { contentRoute } from './content.route';

export class ApiContentService {
  static async fetchContents() {
    return apiInstance.get(contentRoute);
  }

  static async createContent(name, values) {
    return apiInstance.post(contentRoute, { name, value: values });
  }

  static async updateContent(newContentName, newContentValues, contentId) {
    return apiInstance.put(`${contentRoute}/${contentId}`, {
      name: newContentName,
      value: newContentValues
    });
  }

  static async deleteContent(contentId) {
    return apiInstance.delete(`${contentRoute}/${contentId}`);
  }
}
